import { useEffect } from "react";
import * as React from "react";
import { Button, Typography } from 'antd';
import { CheckCircleOutlined } from '@ant-design/icons';

const { Text, Title } = Typography;

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column' as const,
    alignItems: 'center',
    justifyContent: 'center',
    height: '100vh',
    width: '100vw',
    padding: '24px',
    boxSizing: 'border-box' as const,
    textAlign: 'center' as const,
    backgroundColor: '#f6ffed',
  },
  content: {
    backgroundColor: 'white',
    padding: '32px',
    borderRadius: '8px',
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
    maxWidth: '400px',
    width: '100%',
  },
  icon: {
    fontSize: '48px',
    color: '#52c41a',
    marginBottom: '16px',
  },
  title: {
    marginBottom: '16px',
    color: '#262626',
  },
  message: {
    marginBottom: '24px',
    color: '#595959',
    lineHeight: '1.5',
  },
  buttonGroup: {
    display: 'flex',
    gap: '12px',
    justifyContent: 'center',
  },
};

const UploadSuccessPopup: React.FC = () => {
  useEffect(() => {
    Office.onReady().then(() => {
      // Notify parent that the dialog is ready to receive messages
      Office.context.ui.messageParent("ready");  
    });
  }, []);

  const handleClose = () => {
    Office.context.ui.messageParent("close");
  };

  return (
    <div style={styles.container}>
      <div style={styles.content}>
        <div style={styles.icon}>
          <CheckCircleOutlined />
        </div>
        
        <Title level={4} style={styles.title}>
          Upload Successful!
        </Title>
        
        <Text style={styles.message}>
          Your data has been successfully uploaded to the system. 
        </Text>
        
        <div style={styles.buttonGroup}>
          <Button 
            type="primary" 
            onClick={handleClose}
            size="large"
          >
            Close Now
          </Button>
        </div>
      </div>
    </div>
  );
};

const App: React.FC = () => {
  return <UploadSuccessPopup />;
};

export default App; 